import { combineReducers } from 'redux';

import { user } from './userinfo';
import { heatmaps } from './heatmaps';
import { resource } from './resource';
import { current } from './current';
import { scores } from './scores';

const reducer = {
  user,
  heatmaps,
  resource,
  current,
  scores,
};

export default combineReducers(reducer);
